<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import { useContacts } from "~/stores/contacts.store";
import { useChannels } from "~/stores/channel.store";
import { SystemFieldType } from "~/entities/contacts";
import CustomersTableV2 from "~/components/customers/v2/table/CustomersTableV2.vue";

const router = useRouter();
const contactsStore = useContacts();
const channelStore = useChannels();

const props = withDefaults(
  defineProps<{
    hasBeenUpdated: boolean;
  }>(),
  {
    hasBeenUpdated: false,
  }
);

const loading = ref(true);

const showTable = computed<boolean>(() => contactsStore.getCount.all > 0);

onMounted(async () => {
  const nonAvailableToCustomers =
    !channelStore.getChannels.length && !contactsStore.getContacts.length;

  if (nonAvailableToCustomers) {
    await router.push({
      name: "profile",
    });
  }

  if (!props.hasBeenUpdated) {
    contactsStore.filterBuilder.clear();
    const statusField = contactsStore.getSystemFields.find(({ type, name }) => {
      return name === "status" && type === SystemFieldType.Enum;
    })!;
    contactsStore.filterBuilder.type("status", statusField.id, [
      "active",
      "new",
    ]);
  }

  await Promise.all([
    contactsStore.fetchFields(),
    contactsStore.fetchMetaContacts(false),
    contactsStore.fetchTags(),
  ]);

  loading.value = false;
});
</script>

<template>
  <div class="loader-wrapper" v-if="loading">
    <BasePreloader class="preloader" />
  </div>

  <template v-else>
    <div class="layout" v-if="showTable">
      <CustomersTableV2 class="c-table" />
    </div>
    <div class="layout-empty" v-else>
      <CustomersEmpty />
    </div>
  </template>
</template>

<style lang="scss" scoped>
.loader-wrapper {
  margin-top: 32px;
  height: 100%;
  position: relative;

  .preloader {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}

.layout {
  display: grid;
  grid-template-areas:
    "summary"
    "c-table";
  height: 100%;
  grid-template-rows: 0fr auto;
  gap: 10px;
}

.layout-empty {
  display: flex;
  height: 100%;
  gap: $items-spacing;
}

.summary {
  grid-area: summary;
}

.c-table {
  grid-area: c-table;
}
</style>
